/* eslint-disable */
// @ts-nocheck

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import Input from '../../components/forms/Input'
import Select from '../../components/forms/Select'
import Button from '../../components/misc/Button'
import GenericToggle from '../../components/misc/GenericToggle'
import { BasicType, SelectInterface } from '../../interfaces/InterfacesLocal'
import { useAppSelector } from '../../store/hooks'

interface NewAreaProp {
  submitAction: Function
  loading: boolean
}

const NewArea = ({ submitAction, loading }: NewAreaProp) => {
  const { handleSubmit, control, unregister, watch } = useForm()
  const onSubmit: SubmitHandler<BasicType> = (data) => {
    submitAction(data)
  }
  const { areas } = useAppSelector((state) => state.nomenclator)
  const stockAreas = areas.filter((item) => item.type === 'STOCK')

  const [newStock, setNewStock] = useState(false)
  useEffect(() => {
    if (!newStock) unregister('stockAreaId')
  }, [newStock])

  //Area data asociated to Select ------------------------------------------------------------------
  const selectStockData: SelectInterface[] = []
  stockAreas.map((item) => {
    selectStockData.push({
      name: item.name,
      id: item.id,
    })
  })

  const selectModeData: SelectInterface[] = []
  ;[
    { key: 'BYORDERS', value: 'Por tickets recibidos' },
    { key: 'PRODUCTION', value: 'Proceso productivo' },
    { key: 'KITCHEN', value: 'Cocina 2.0' },
    { key: 'DISPATCH_STOCK', value: 'Almacén de despacho' },
  ].map((item) => {
    selectModeData.push({
      name: item.value,
      id: item.key,
    })
  })

  const types: SelectInterface[] = [
    { id: 'STOCK', name: 'Almacén' },
    { id: 'SALE', name: 'Punto de venta' },
    { id: 'MANUFACTURER', name: 'Procesado' },
    { id: 'ACCESSPOINT', name: 'Punto de Acceso' },
  ]

  //--------------------------------------------------------------------------------------------

  const areaType = watch('type')
  let textInfo = ''

  switch (areaType) {
    case 'SALE':
      textInfo =
        'Las áreas de tipo Punto de venta son aquellas que se encargan de gestionar las ventas de cara al cliente. Al crear un área de este tipo, se crea automáticamente un área de almacén asociada a ella, donde podrás tener el control de los recursos que allí se venden y sus movimientos.'
      break

    case 'STOCK':
      textInfo =
        'En las áreas de tipo almacén podrás tener el control de los recursos de tu inventario y sus movimientos.'
      break

    case 'MANUFACTURER':
      textInfo =
        'Las áreas de tipo producción son aquellas donde ocurren procesos de que implican elaboración o confección de productos con mayor preparado, por ejemplo: la cocina, la parrillada, un taller, etc. De igual manera que el tipo anterior, al crear un área de producción, un almacén asociado a esta se creará automáicamente.'
      break

    default:
      break
  }

  return (
    <div className="md:grid md:grid-cols-3 md:gap-6">
      <div className="md:col-span-1">
        <div className="px-4 sm:px-0">
          <h3 className="text-lg font-medium leading-6 text-slate-900">
            Nueva área
          </h3>
          <p className="mt-1 text-justify text-sm text-slate-600">
            Crea un área para mayor organización de tu negocio, existen cuatro
            tipos de áreas: almacén, punto de venta, producción y punto de
            acceso.
          </p>
          {textInfo !== '' && (
            <p className="mt-1 p-2 text-justify text-sm font-light text-slate-600">
              {textInfo}
            </p>
          )}
        </div>
      </div>
      <div className="mt-5 md:col-span-2 md:mt-0">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="shadow sm:overflow-visible sm:rounded-md">
            <div className="space-y-6 bg-white px-4 py-5 sm:p-6">
              <div className="flex-col">
                <Input
                  control={control}
                  label="Nombre"
                  name="name"
                  placeholder="Nombre del área"
                  rules={{
                    required: 'Este campo es requerido',
                    validate: (value) =>
                      !areas.some((area) => area.name === value) ||
                      'Nombre de área existente',
                  }}
                />
                <Input
                  control={control}
                  label="Código"
                  name="code"
                  placeholder="Código del área"
                  rules={{
                    required: 'Este campo es requerido',
                    validate: (value) =>
                      !areas.some((area) => area.code === value) ||
                      'Código de área existente',
                  }}
                />
                <Select
                  control={control}
                  data={types}
                  label="Tipo de área"
                  name="type"
                  rules={{ required: 'Campo requerido' }}
                />
              </div>
              {['SALE', 'MANUFACTURER'].includes(areaType ?? '') && (
                <>
                  <GenericToggle
                    changeState={setNewStock}
                    currentState={newStock}
                    title="Asociar a un almacén existente"
                  />
                  {newStock && (
                    <Select
                      control={control}
                      data={selectStockData}
                      label="Almacén asociado"
                      name="stockAreaId"
                      rules={{
                        required:
                          'Seleccione un área asociada o desactive la opción',
                      }}
                    />
                  )}
                </>
              )}

              <div>
                {['MANUFACTURER'].includes(areaType ?? '') && (
                  <Select
                    control={control}
                    data={selectModeData}
                    label="Modo de visualización"
                    name="productionMode"
                    rules={{
                      required: 'Seleccione un modo de visualización ',
                    }}
                  />
                )}
              </div>

              <div className="flex justify-end">
                <Button
                  color="slate-600"
                  disabled={loading}
                  loading={loading}
                  name="Crear"
                  type="submit"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default NewArea
